// extracted by mini-css-extract-plugin
export default {"tabs":"index_tabs_KM0EU","current":"index_current_Xe5t-","search":"index_search_3P4bD"};